<template>
  <div class="svg50ar" ref="svgTarget">
    <svg
      height="550"
      preserveAspectRatio="xMidYMid meet"
      width="550"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="group1">
        <circle
          cx="275"
          cy="275"
          fill="white"
          r="77.2"
          stroke="black"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="white"
          r="69.2"
          stroke="black"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="white"
          r="61.2"
          stroke="black"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="blank"
          r="56.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="53.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="45.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="37.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="29.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="21.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="black"
          r="13.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="blank"
          r="5.2"
          stroke="white"
          stroke-width="0.4"
        />
        <circle
          cx="275"
          cy="275"
          fill="blank"
          r="2.5"
          stroke="white"
          stroke-width="0.4"
        />
        <text fill="black" font-size="4" stroke-width="0" x="274" y="203.4">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="274" y="350.2">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="346.8" y="277">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="200.8" y="277">
          1
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="274" y="210.4">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="274" y="342.2">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="338.8" y="277">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="208.8" y="277">
          2
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="274" y="218.4">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="274" y="334.2">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="330.8" y="277">
          3
        </text>
        <text fill="black" font-size="4" stroke-width="0" x="216.8" y="277">
          3
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="226.4">
          4
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="326.2">
          4
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="322.8" y="277">
          4
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="224.8" y="277">
          4
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="234.4">
          5
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="318.2">
          5
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="314.8" y="277">
          5
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="232.8" y="277">
          5
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="242.4">
          6
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="310.2">
          6
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="306.8" y="277">
          6
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="240.8" y="277">
          6
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="250.4">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="302.2">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="298.8" y="277">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="248.8" y="277">
          7
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="259.4">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="274" y="294.2">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="290.8" y="277">
          8
        </text>
        <text fill="white" font-size="4" stroke-width="0" x="256.8" y="277">
          8
        </text>
      </g>
      <g v-for="(item, idx) in dataitem" :key="idx">
        <circle
          v-if="item.x != ''"
          :cx="centerPosition + item.x * 1"
          :cy="centerPosition - item.y * 1"
          :fill="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
          :r="bulletRadius"
          stroke="black"
          stroke-width="0.4"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.8,
      // 中心点
      centerPosition: 275,
      // 靶面直径（0环大小）
      diameter: 154.4,
      // 初始缩放比率
      initScale: 1,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
      zoomSetting: [1,1,1,2.2,3.8,5.8]
    };
  },
  watch: {
    lastscore: {
      handler: function(newVal) {
        this.scaleZoom(newVal);
      },
      immediate: true
    }
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function(attribute, val) {
      this.$refs.svgTarget?this.$refs.svgTarget.style.setProperty(attribute, val):"";
    },
    scaleZoom: function(newVal) {
      let idx = 0;
      if (newVal == "") {
        idx = 0;
      } else {
        idx = Math.floor(newVal / 2);
      }
      this.setProperty("--transScale", this.initScale * this.zoomSetting[idx]);
    }
  },
  mounted() {
    const parentContainerHeight =
      document.getElementsByClassName("targetContainer")[0].clientHeight;
      
    // -0.1杜绝1像素问题
    this.initScale = parentContainerHeight / this.diameter - 0.1;

    this.margin =
        (parentContainerHeight - this.centerPosition * 2) / 2 + "px";
      this.setProperty("--margin", this.margin);
      this.setProperty("--transScale", this.initScale);
    this.scaleZoom(this.lastscore);
  },
  props: ["dataitem", "lastscore"]
};
</script>
<style lang="less" scoped>
.svg50ar {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;
  --margin: 0px;
  // overflow: hidden;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top:  var(--margin);
  }
}
</style>
